import {Component, ViewChild} from '@angular/core';
import {AlertController, Events, NavController, Platform} from 'ionic-angular';
import {StatusBar} from '@ionic-native/status-bar';
import {SplashScreen} from '@ionic-native/splash-screen';

import {TabsPage} from '../pages/tabs/tabs';
import {latLng, LocationServiceProvider} from "../providers/location-service/location-service";
import {Dialogs} from "@ionic-native/dialogs";
import {PushNotificationServiceProvider} from "../providers/push-notification-service/push-notification-service";
import {AppVersion} from "@ionic-native/app-version";
import {HttpClient} from "@angular/common/http";
import {InAppBrowser, InAppBrowserOptions} from "@ionic-native/in-app-browser";
import {StripeServiceProvider} from "../providers/stripe-service/stripe-service";
import {UserServiceProvider} from "../providers/user-service/user-service";
// import * as Sentry from 'sentry-cordova';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('myNav') nav: NavController;

  rootPage: any = TabsPage;
  showGeolocationAlert: boolean;
  appName: string;
  packageName: string;
  versionCode: number;
  versionNumber: string;
  platformSource: string;

  constructor(
    private platform: Platform,
    public statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private locationService: LocationServiceProvider,
    private pushService: PushNotificationServiceProvider,
    private appVersion: AppVersion,
    private events: Events,
    private iab: InAppBrowser,
    private http: HttpClient,
    private alertCtrl: AlertController,
    private dialogs: Dialogs,
    private stripeService: StripeServiceProvider,
    private userService: UserServiceProvider,
  ) {
    platform.ready().then((source) => {

      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.getLocation();

      if (this.platform.is('cordova')) {
     
        // if (process.env.SENTRY_DSN) {
          // Sentry.init({
          //   environment: process.env.ENV,
          //   dsn: 'https://e833bf4b0041d2d74301d50951fcc616@o4505803595186176.ingest.sentry.io/4505826969387008',
          //   release: '1.1.1',
          //   debug: true
          // });
        // }

        this.statusBar.styleDefault();
        this.statusBar.overlaysWebView(false);
        if (this.platform.is('ios')) {
          this.platformSource = 'ios';
          this.statusBar.backgroundColorByHexString("#FFFFFF");
        }

        if (this.platform.is('android')) {
          this.platformSource = 'android';
        }

        // Subscribes to the resume event so that each time the user
        // opens the app they're asked if they would like to update
        // if an update is available.

        this.platform.ready().then(() => {
          
          this.checkUpdate().then((res: any) => {
            if (res.url) {
              this.presentAlert(res.url);
            }
          });
          this.userService.setUserLastBookingTeamId();
        });

        this.userService.setUserLastBookingTeamId();

      }

      this.showGeolocationAlert = true;
      events.subscribe('geolocation:retry', () => {
        this.getLocation();
        this.showGeolocationAlert = false;
      });

      setTimeout(() => {
        this.splashScreen.hide();

        if (localStorage.getItem('tuid')) {
          this.pushService.handleEvents();
        }

      }, 100);
    });
  }

  getLocation() {
    this.locationService.geolocate().then((latLng: latLng) => {
      this.locationService.getCurrentLocationName(latLng.lat, latLng.lng);
      this.events.publish('geolocation:latLng', latLng);
    }).catch((error) => {
      if (this.showGeolocationAlert) {
        this.events.publish('geolocation:latLng', {});
        this.dialogs.alert('We are having trouble discovering your location. Please ensure location service is enabled in your settings and reload the app. Or continue using Tuipoint with location off?')
          .then(() => this.events.publish('geolocation:retry'))
          .catch(e => console.log('Error displaying dialog', e));
      }
    });
  }

  checkUpdate() {

    return new Promise((resolve, reject) => {
      this.appVersion.getAppName().then((res) => {
        this.appName = res;
        this.appVersion.getPackageName().then((res) => {
          this.packageName = res;
          this.appVersion.getVersionCode().then((res: any) => {
            this.versionCode = res;
            this.appVersion.getVersionNumber().then((res) => {
              this.versionNumber = res;
              console.log({
                app_name: this.appName,
                package_name: this.packageName,
                version_code: this.versionCode,
                version_number: this.versionNumber,
                platform: this.platformSource
              });
              
              this.http.post(`/check-app-version`, {
                app_name: this.appName,
                package_name: this.packageName,
                version_code: this.versionCode,
                version_number: this.versionNumber,
                platform: this.platformSource
              }).subscribe(res => {
                console.log("res",res);
                
                resolve(res)
              }, error => {
                reject(error)
              })
            });
          });
        });
      });
    });
  }

  presentAlert(storeUrl) {
    let alert = this.alertCtrl.create({
      title: 'Major update',
      subTitle: "Please update to proceed.",
      enableBackdropDismiss: false,
      buttons: [
        // {
        //   text: 'Update Later',
        //   handler: () => {
        //     alert.dismiss();
        //     return false;
        //   }
        // },
        {
          text: 'Update',
          handler: () => {
            const options: InAppBrowserOptions = {
              location: 'no'
            };
            const browser = this.iab.create(storeUrl, '_system', options);
            return false;
          }
        }
      ]
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts